module.exports = __webpack_public_path__ + "static/media/indo-pacific-sailfish.6250b2a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/indo-pacific-sailfish.png
// module id = 319
// module chunks = 0